export default __webpack_public_path__ + "static/bg_glow_footer-e06da5feef0edfccb1fa54a3820f1ded.png";